
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-safe/load",
      function () {
        return require("private-next-pages/new-safe/load.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-safe/load"])
      });
    }
  